<template>
  <div class="inline-flex flex-col m-1 p-1 items-center min-h-fit max-w-fit relative sm:p-4
    box-border sm:m-3 rounded-lg cursor-pointer"
    :class="{ 'border-2 border-[var(--color-orange)]': isSelected }">
    <div class="w-14 h-14 overflow-hidden rounded-full lg:w-20 lg:h-20">
      <img :src="getProfilePicture" alt="Profile picture" class="w-full h-full"/>
    </div>
    <p class="text-center break-words">{{ name }}</p>
    <i v-if="isSelected" class="absolute text-[var(--color-orange)] text-4xl -right-4 -top-5
        sm:text-5xl sm:-top-9 sm:-right-6">
      <font-awesome-icon icon="fa-hands-clapping"/>
    </i>
  </div>
</template>

<script>
import defaultProfileImage from '@/assets/defaultProfileImage.js';

export default {
  props: {
    isSelected: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: '',
    },
    pictureUrl: {
      type: String,
      default: '',
    },
  },
  name: 'KssChampionProfile',
  computed: {
    getProfilePicture() {
      if (this.pictureUrl) {
        return this.pictureUrl;
      }

      return defaultProfileImage;
    },
  },
};
</script>
